import React from 'react';

/** Format ISO date (YYYY-MM-DD) for display as DD/MM/YYYY per story screenshots. */
export function formatAnalyticsDateDisplay(isoDate: string): string {
  if (!isoDate) {
    return '';
  }
  const [y, m, d] = isoDate.split('-');
  if (!y || !m || !d) {
    return isoDate;
  }
  return `${d}/${m}/${y}`;
}

export function AnalyticsDateInput({
  value,
  onChange,
  min,
  max,
  label,
}: Readonly<{
  value: string;
  onChange: (v: string) => void;
  min?: string;
  max?: string;
  label: string;
}>) {
  return (
    <div className="analytics-filter-field">
      <label>{label}</label>
      <input
        type="date"
        value={value}
        min={min}
        max={max}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  );
}
